import { useEffect, useState } from "react";
import Loader from "../shared/loader";
import api from "../api/api";
import _enum from "../../utilities/enum";
import Modal from 'react-bootstrap/Modal';
import { Link } from "react-router-dom";
import { fetchStatusDisplayUtils } from "../../utilities/dataTableCellUtils";
import stringHelpers from "../../utilities/stringHelpers";
import { toDateString } from "../../utilities/dateUtilities";

export default function NotificationsManagement(props) {
    const [allNotifications, setAllNotifications] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [deleteId, setDeleteId] = useState(null);

    const handleDelete = (id) => {
        api.deleteNotification(
            id,
            () => {
                setDeleteId(null);
                fetchAllNotifications();
            },
            error => console.log(error),
            props.token
        )
    }

    const fetchAllNotifications = () => {
        setIsLoading(true)
        api.getNotifications(
            data => {
                setAllNotifications(data);
                setIsLoading(false);
            },
            error => {
                setIsLoading(false);
                console.log(error);
            },
            props.token
        )
    }

    useEffect(() => fetchAllNotifications(), [])

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="pr-0">
                                    <h5 className="fs-0 mb-0 text-nowrap py-2 py-xl-0">Notifications</h5>
                                </div>
                                <div className="d-flex">
                                    <Link to={`/notifications/add`}>
                                        <button className="btn btn-success btn-sm mr-1 ml-2 nowrap" onClick={ () => { } }>
                                            <i className="fas fa-plus mr-1"></i>Add Notification
                                        </button>
                                    </Link>
                                    <button
                                        className="btn btn-primary btn-sm mr-1 ml-1 nowrap"
                                        onClick={ fetchAllNotifications }>
                                        <i className="fas fa-redo mr-1"></i>Refresh
                                    </button>
                                </div>
                            </div>
                        </div>

                        {
                            isLoading
                                ? <Loader />
                                : <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                                    <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                        <thead className="bg-200 text-900">
                                            <tr>
                                                <th>Type</th>
                                                <th>Notification</th>
                                                <th>Expiry Date</th>
                                                <th>&nbps;</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                allNotifications && allNotifications.length > 0 && allNotifications.map((item, index) =>
                                                    <tr key={ index }>
                                                        <td>
                                                            <div className="d-flex align-items-center">{ fetchStatusDisplayUtils(item.notificationType).icon }{ _enum.NotificationType[item.notificationType] }</div>
                                                        </td>
                                                        <td>{ item.message }</td>
                                                        <td>{ !stringHelpers.isNullOrEmpty(item.expiryDate) ? toDateString(item.expiryDate) : item.expiryDate }</td>
                                                        <td className="pr-3">
                                                            <div className="d-flex justify-content-end">
                                                                <Link to={ `/notifications/${ item.id }` }><button className='far fa-edit mr-2 btn py-0 px-1'></button></Link>
                                                                <button onClick={ () => setDeleteId(item.id) } className='fas fa-trash-alt btn py-0 px-1'></button>
                                                            </div>
                                                        </td>
                                                    </tr>)
                                            }
                                        </tbody>
                                    </table>
                                </div>
                        }
                    </div>
                </div>
            </div>
            {
                deleteId &&
                <Modal show onHide={ () => setDeleteId(null) }>
                    <Modal.Header>
                        <Modal.Title>
                            Delete Notification
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12 ">
                                <p className="font-weight-semi-bold  mt-1 mb-2">Are you sure you want to delete this notification?</p>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button
                            className="btn btn-sm btn-danger mt-1"
                            onClick={ () => { setDeleteId(null) } }
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-sm btn-success mt-1"
                            onClick={ () => handleDelete(deleteId) }
                        >
                            Confirm
                        </button>
                    </Modal.Footer>
                </Modal>
            }
        </div>
    )
}